import styled from 'styled-components';
import { CalendarTodayRounded, Lock } from '@material-ui/icons';
import { palette } from '@/theme';
import { UIBox } from '@/components/ui/Box';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

export const ListItem = styled(UIBox)`
  width: 100%;
  padding: 20px;
  border-radius: 4px;
  background: ${palette.colors.midGrey};
  border: 1px solid #dedede;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  flex-direction: column;
  cursor: default;
`;

export const CalendarIcon = styled(CalendarTodayRounded)`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;

export const Actions = styled(UIBox)`
  align-items: center;
  gap: 24px;
  margin-left: auto;
`;

export const Unlock = styled(Lock)`
  width: 24px;
  height: 24px;
  margin-left: 8px;
`;

export const ErrorIcon = styled(ErrorOutlineIcon)`
  margin-right: 8px;
  height: 16px;
  width: 16px;
`;
